import { Box, Stack, Typography, Alert, LinearProgress } from '@mui/material';

/**
 * Section wrapper used by the Overview and Activity tabs. Each section loads
 * and fails independently — a section-level error renders inline so the rest of
 * the tab stays usable ("Other sections still available").
 */
export default function Section({ title, count, action, loading, error, children }) {
  return (
    <Box sx={{ mb: 3 }}>
      <Stack direction="row" alignItems="center" spacing={1} sx={{ mb: 1 }}>
        <Typography variant="subtitle1" sx={{ fontWeight: 700 }}>{title}</Typography>
        {typeof count === 'number' && (
          <Typography variant="body2" color="text.secondary">({count})</Typography>
        )}
        <Box sx={{ flex: 1 }} />
        {action}
      </Stack>
      {loading && <LinearProgress sx={{ mb: 1, borderRadius: 1 }} />}
      {error
        ? <Alert severity="warning" variant="outlined">{title} could not load — {error}. Other sections are still available.</Alert>
        : children}
    </Box>
  );
}
